import { Box, Divider, Typography } from "@material-ui/core";
import React from "react";
import Text from "../../../../../../../shared/components/Text";

export const DataRow = ({ label, value, hideDivider = false }) => {
  return (
    <>
      <Box
        my={1}
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography variant={"body2"} color={"textPrimary"} align={"left"}>
          <Text tId={label} />
        </Typography>
        <Typography variant={"body2"} color={"textPrimary"} align={"right"}>
          <strong>{value}</strong>
        </Typography>
      </Box>
      {!hideDivider && <Divider light />}
    </>
  );
};
